
  export default {
    name: 'ThemeStoresMobileIosAbout'
  }
